import { FeedOutlined } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';

import type { RelatedCode } from '@/features/Factsheet';

const RelatedCodeItem = ({
  relatedCode,
  openNewTab
}: {
  relatedCode: RelatedCode;
  openNewTab: (code: string) => void;
}) => {
  return (
    <Box sx={{ pb: 1, display: 'flex', alignItems: 'center' }}>
      <IconButton
        sx={{ width: 28, height: 28, mr: 0.5 }}
        onClick={() => {
          openNewTab(relatedCode.code);
        }}
      >
        <FeedOutlined sx={{ fontSize: 16 }} />
      </IconButton>
      <Typography sx={{ fontWeight: 700, mr: 2 }}>{relatedCode.code}</Typography>
      <Typography>{relatedCode.title}</Typography>
    </Box>
  );
};

export default RelatedCodeItem;
